// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file travel/v1/exchange.proto (package travel.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { AgencyInfo } from "../../agency/v1/agency_pb";
import { file_agency_v1_agency } from "../../agency/v1/agency_pb";
import type { Ancillary, Flexibility, Journey, Passenger, PlaneCabinClass, Price, PriceByPassenger, ProductBySegmentsAndPassengers, TrainCabinClass, Travel } from "./common_pb";
import { file_travel_v1_common } from "./common_pb";
import type { SearchDate } from "./search_pb";
import { file_travel_v1_search } from "./search_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travel/v1/exchange.proto.
 */
export const file_travel_v1_exchange: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agency_v1_agency, file_travel_v1_common, file_travel_v1_search]);

/**
 * @generated from message travel.v1.ExchangeServiceSearchRequest
 */
export type ExchangeServiceSearchRequest = Message<"travel.v1.ExchangeServiceSearchRequest"> & {
  /**
   * @generated from field: string travel_id = 1;
   */
  travelId: string;

  /**
   * @generated from field: string journey_id = 2;
   */
  journeyId: string;

  /**
   * @generated from field: travel.v1.SearchDate date = 3;
   */
  date?: SearchDate;
};

/**
 * Describes the message travel.v1.ExchangeServiceSearchRequest.
 * Use `create(ExchangeServiceSearchRequestSchema)` to create a new message.
 */
export const ExchangeServiceSearchRequestSchema: GenMessage<ExchangeServiceSearchRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_exchange, 0);

/**
 * @generated from message travel.v1.ExchangeServiceSearchResponse
 */
export type ExchangeServiceSearchResponse = Message<"travel.v1.ExchangeServiceSearchResponse"> & {
  /**
   * @generated from field: string travel_id = 1;
   */
  travelId: string;

  /**
   * @generated from field: repeated travel.v1.ExchangeSolution solutions = 2;
   */
  solutions: ExchangeSolution[];

  /**
   * @generated from field: repeated travel.v1.Passenger passengers = 3;
   */
  passengers: Passenger[];

  /**
   * @generated from field: agency.v1.AgencyInfo agency_info = 4;
   */
  agencyInfo?: AgencyInfo;

  /**
   * @generated from field: repeated string warnings = 5;
   */
  warnings: string[];
};

/**
 * Describes the message travel.v1.ExchangeServiceSearchResponse.
 * Use `create(ExchangeServiceSearchResponseSchema)` to create a new message.
 */
export const ExchangeServiceSearchResponseSchema: GenMessage<ExchangeServiceSearchResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_exchange, 1);

/**
 * @generated from message travel.v1.ExchangeSolution
 */
export type ExchangeSolution = Message<"travel.v1.ExchangeSolution"> & {
  /**
   * @generated from field: travel.v1.Journey journey = 1;
   */
  journey?: Journey;

  /**
   * @generated from field: repeated travel.v1.ExchangeOffer offers = 2;
   */
  offers: ExchangeOffer[];

  /**
   * @generated from field: optional string more = 3;
   */
  more?: string;
};

/**
 * Describes the message travel.v1.ExchangeSolution.
 * Use `create(ExchangeSolutionSchema)` to create a new message.
 */
export const ExchangeSolutionSchema: GenMessage<ExchangeSolution> = /*@__PURE__*/
  messageDesc(file_travel_v1_exchange, 2);

/**
 * @generated from message travel.v1.ExchangeOffer
 */
export type ExchangeOffer = Message<"travel.v1.ExchangeOffer"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from oneof travel.v1.ExchangeOffer.cabin_class
   */
  cabinClass: {
    /**
     * @generated from field: travel.v1.TrainCabinClass train_cabin_class = 2;
     */
    value: TrainCabinClass;
    case: "trainCabinClass";
  } | {
    /**
     * @generated from field: travel.v1.PlaneCabinClass plane_cabin_class = 3;
     */
    value: PlaneCabinClass;
    case: "planeCabinClass";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: travel.v1.Flexibility flexibility = 4;
   */
  flexibility: Flexibility;

  /**
   * @generated from field: travel.v1.Price initial_price = 5;
   */
  initialPrice?: Price;

  /**
   * @generated from field: travel.v1.Price subsidy_amount = 6;
   */
  subsidyAmount?: Price;

  /**
   * @generated from field: travel.v1.Price out_of_pocket_amount = 7;
   */
  outOfPocketAmount?: Price;

  /**
   * @generated from field: repeated travel.v1.PriceByPassenger prices = 8;
   */
  prices: PriceByPassenger[];

  /**
   * @generated from field: repeated travel.v1.ProductBySegmentsAndPassengers products = 9;
   */
  products: ProductBySegmentsAndPassengers[];

  /**
   * @generated from field: repeated travel.v1.Ancillary ancillaries = 10;
   */
  ancillaries: Ancillary[];

  /**
   * @generated from field: bool is_compliant = 11;
   */
  isCompliant: boolean;

  /**
   * @generated from field: travel.v1.Price exchange_fees = 12;
   */
  exchangeFees?: Price;

  /**
   * @generated from field: travel.v1.Price price_delta = 13;
   */
  priceDelta?: Price;

  /**
   * @generated from field: travel.v1.Price new_price = 14;
   */
  newPrice?: Price;

  /**
   * @generated from field: bool is_exchangeable = 15;
   */
  isExchangeable: boolean;

  /**
   * @generated from field: bool is_passport_required = 16;
   */
  isPassportRequired: boolean;
};

/**
 * Describes the message travel.v1.ExchangeOffer.
 * Use `create(ExchangeOfferSchema)` to create a new message.
 */
export const ExchangeOfferSchema: GenMessage<ExchangeOffer> = /*@__PURE__*/
  messageDesc(file_travel_v1_exchange, 3);

/**
 * @generated from message travel.v1.ExchangeServiceConfirmRequest
 */
export type ExchangeServiceConfirmRequest = Message<"travel.v1.ExchangeServiceConfirmRequest"> & {
  /**
   * @generated from field: string travel_id = 1;
   */
  travelId: string;

  /**
   * @generated from field: string journey_id = 2;
   */
  journeyId: string;

  /**
   * @generated from field: string offer_id = 3;
   */
  offerId: string;
};

/**
 * Describes the message travel.v1.ExchangeServiceConfirmRequest.
 * Use `create(ExchangeServiceConfirmRequestSchema)` to create a new message.
 */
export const ExchangeServiceConfirmRequestSchema: GenMessage<ExchangeServiceConfirmRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_exchange, 4);

/**
 * @generated from message travel.v1.ExchangeServiceConfirmResponse
 */
export type ExchangeServiceConfirmResponse = Message<"travel.v1.ExchangeServiceConfirmResponse"> & {
  /**
   * @generated from field: travel.v1.Travel travel = 1;
   */
  travel?: Travel;
};

/**
 * Describes the message travel.v1.ExchangeServiceConfirmResponse.
 * Use `create(ExchangeServiceConfirmResponseSchema)` to create a new message.
 */
export const ExchangeServiceConfirmResponseSchema: GenMessage<ExchangeServiceConfirmResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_exchange, 5);

/**
 * @generated from service travel.v1.ExchangeService
 */
export const ExchangeService: GenService<{
  /**
   * @generated from rpc travel.v1.ExchangeService.Search
   */
  search: {
    methodKind: "unary";
    input: typeof ExchangeServiceSearchRequestSchema;
    output: typeof ExchangeServiceSearchResponseSchema;
  },
  /**
   * @generated from rpc travel.v1.ExchangeService.Confirm
   */
  confirm: {
    methodKind: "unary";
    input: typeof ExchangeServiceConfirmRequestSchema;
    output: typeof ExchangeServiceConfirmResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travel_v1_exchange, 0);

